import React from "react";
import withStyles from '@mui/styles/withStyles';

import { toUpperCaseNoAccent } from 'utils/stringHelper';


import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';


import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';


import Button from '@mui/material/Button';



const styles = theme => ({

    dialogContent: {
        display: 'flex',
        flexDirection: 'column'
    }

});

const AddCausePrincipaleDialog = ({ classes, onClose, onClickSave }) => {

    const [code, setCode] = React.useState('');
    const [libelle, setLibelle] = React.useState('');
       

    const save = () => {

        var causePrincipale = {
            libelle: libelle,
            code: code
        };

        onClickSave(causePrincipale);
        onClose();
    };

    return (
        <Dialog open>
            <DialogTitle>Nouvelle cause principale</DialogTitle>

            <DialogContent className={classes.dialogContent}>


                <FormControl margin="normal">
                    <FormLabel component="legend" required>Libellé</FormLabel>
                    <TextField
                        id="libelle"
                        name="libelle"
                        placeholder="Saisir un libellé"
                        value={libelle}
                        onChange={e => setLibelle(e.target.value)}
                    />
                </FormControl>

                <FormControl margin="normal">
                    <FormLabel component="legend" required>Code</FormLabel>
                    <TextField
                        id="code"
                        name="code"
                        placeholder="Saisir un code"
                        value={code}
                        onChange={e => setCode(toUpperCaseNoAccent(e.target.value))}
                    />
                </FormControl>
                           

            </DialogContent>

            <DialogActions>
                <Button
                    onClick={onClose}
                    color="primary"
                >
                    Annuler
                </Button>
                <Button
                    onClick={save}
                    variant="contained"
                    color="secondary"
                    disabled={!libelle || !code}
                >
                    Enregistrer
                </Button>
            </DialogActions>
        </Dialog>
    );
};


export default withStyles(styles)(AddCausePrincipaleDialog);
